'use client'

import { Cell, Image, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import type { Slide, ABTestConfig } from '../newContentTestConfig'
import { BulletPointList } from '../BulletPointList'

type Props = {
  slide: Slide
  config: ABTestConfig
}

export const IntroSlide = ({ slide, config }: Props) => {
  const translate = useTranslate('conversation.phishing_first_time_lister_education')
  const asset = useAsset('/assets/phishing-first-time-lister-education')
  const titleAlignment = slide.bulletPoints ? Text.Alignment.Left : Text.Alignment.Center

  return (
    <Cell>
      {config.showIntroSpacer && <Spacer size={Spacer.Size.X3Large} />}
      <div className="u-flexbox">
        <Image
          src={asset(slide.image, { theme: { dark: `dark/${slide.image}` } })}
          size={Image.Size.X3Large}
          alt={translate(slide.title)}
          scaling={Image.Scaling.Contain}
        />
      </div>
      <Spacer size={Spacer.Size.Large} />
      <Text
        as="h1"
        text={translate(slide.title)}
        type={config.titleType}
        alignment={titleAlignment}
        width={Text.Width.Parent}
      />
      <Spacer size={Spacer.Size.Large} />
      <Text
        as="span"
        text={translate(slide.body)}
        type={Text.Type.Body}
        alignment={Text.Alignment.Left}
        html
      />
      {slide.bulletPoints && <BulletPointList bulletPoints={slide.bulletPoints} />}
    </Cell>
  )
}
